import _ from 'lodash'
import app, { api } from 'xadmin'
import { effects } from 'redux-saga'
const { all, put, select, takeEvery } = effects

function* handle_add_model({ model }) {
  const { store } = app.context
  try {
    const modelState = store.getState().model[model.key]
    const { ids } = modelState
    const current = store.getState().cmdb.current
    if (!current && ids && !_.isElement(ids)) {
      // 初始化不默认选中第一个模型
      // yield put({ type: '@@cmdb/CHANGE_CURRENT', id: ids[0] })
    }
  } catch (error) {
    console.error(error)
  }
}
function* handle_change_model({ item }) {
  yield put({ type: '@@cmdb/CHANGE_CURRENT', id: item.id, ...item })
}
function* handle_delete_model({ model, item }) {
  const { store } = app.context
  try {
    const modelState = store.getState().model[model.key]
    const { ids } = modelState
    if (ids && !_.isEmpty(ids)) {
      // 删除不默认选中第一个模型 & 
      yield put({ type: '@@cmdb/CHANGE_CURRENT', id: null })
    }
  } catch (error) {
    console.error(error)
  }
}

export default (app) => function* () {
  yield all([
    takeEvery(action => action.model && action.model.name == 'model' && action.type == 'GET_ITEMS' && action.items != undefined, handle_add_model),
    takeEvery(action => action.model && action.model.name == 'model' && action.type == 'SAVE_ITEM' && action.success === true, handle_change_model),
    takeEvery(action => action.model && action.model.name == 'model' && action.type == 'DELETE_ITEM', handle_delete_model),
  ])
}
